import { Box, Heading, Image, Stack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import banner from "../../assets/banner.svg";
import {FaAngellist, FaGithub} from "react-icons/fa";
import { Card, CardBody, CardFooter } from '@chakra-ui/react';
import {BiLinkAlt} from "react-icons/bi"
import med from "../../assets/med.png";
import polls from "../../assets/polls.png";
import "./home.css";
const Home = () => {
  return (
    <section className='home'>
    <div className='container'>
    <Stack 
             direction={["column","row"]}
             height="100%"
             justifyContent={["center","space-between"]}
             alignItems={"center"}
             spacing={["16","56"]} >
              <VStack width="full" alignItems={["left","flex-start"]} className='v-container' spacing={"5"}>
                    <Heading children="Namaste." fontWeight={'semibold'} color={'#362FD9'} />
                    <Text  children="I am Avi, a software developer, merging frontend design with web3 to create secure and decentralized projects for the future." fontSize={"xl"} fontWeight={'semibold'} letterSpacing={2} textAlign="justify"/>
              </VStack>
              <Image src={banner} boxSize={"md"} objectFit={"contain"} className='banner' padding={"2"}/>

    </Stack>
    </div>
    <Box padding={"8"} justifyContent={"flex"} display={'flex'}  paddingLeft={"10"}>
      <FaAngellist size={24}></FaAngellist>
      <Text children="Featured Work" fontWeight={'bold'} fontSize={'xl'} textTransform={'uppercase'}/>
    </Box>
    <Box paddingLeft={["5","10"]} paddingRight={["5","20"]} paddingBottom={5} >
    <Card direction={{ base: 'column', sm: 'row' }}
    overflow='hidden'
    variant='outline'
    padding={5}
  >
  <Image
    objectFit='cover'
    maxW={{ base: '100%', sm: '500px' }}
    src={med}
    alt='med3-icon'
  />

  <Stack padding={5}>
    <CardBody>
      <Heading size='md'>MED3</Heading>

      <Text py='2'>
      MED3 is a cutting-edge Electronic Health Record (EHR) system that utilizes blockchain technology for secure and efficient health data management. With MED3, healthcare providers can securely access and share patient health data in a decentralized manner, leading to improved patient outcomes.
      </Text>
    </CardBody>

    <CardFooter justifyContent={"space-between"}>
      <a href='https://github.com/avibhawnani/MED3'><FaGithub size={24}></FaGithub></a>
      <a href="https://med-three.netlify.app/"><BiLinkAlt size={24}></BiLinkAlt></a>
      <Text alignContent={["right",""]} textAlign={"right"} textTransform={'uppercase'}>Sep 2022 - May 2023 • REMOTE</Text>
    </CardFooter>
  </Stack>
</Card>
</Box>

    <Box paddingLeft={["5","10"]} paddingRight={["5","20"]} paddingBottom={5} >
    <Card direction={{ base: 'column', sm: 'row' }}
    overflow='hidden'
    variant='outline'
    padding={5}
  >
  <Image
    objectFit='cover'
    maxW={{ base: '100%', sm: '500px' }}
    src={polls}
    alt='med3-icon'
  />

  <Stack padding={5}>
    <CardBody>
      <Heading size='md'>Polling dApp</Heading>

      <Text py='2'>
      Introducing our groundbreaking polling system project empowered by blockchain technology. By leveraging the security and transparency of blockchain, our system ensures verifiable and tamper-proof voting, promoting trust, efficiency, and integrity in the democratic process.
      </Text>
    </CardBody>

    <CardFooter justifyContent={"space-between"}>
      <a href="https://github.com/avibhawnani/PollingSystem"><FaGithub size={24}></FaGithub></a>
      <a href="https://polling.spritle.com/"><BiLinkAlt size={24}></BiLinkAlt></a>
      <Text alignContent={["right",""]} textAlign={"right"} textTransform={'uppercase'}>Jan 2023 - Feb 2023 • REMOTE</Text>
    </CardFooter>
  </Stack>
</Card>
    </Box>
    </section>
  )
}

export default Home